/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Editor from 'DesignSystem/Editor/react'
import InlineNoteEditor from 'DesignSystem/InlineNoteEditor/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/AppointmentOverlay/Content/Form/Content/NotesInput/Content",
  onChange
  
}) {
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let appointmentOverlayNoteValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'note',
})
let appointmentOverlayNoteChangeData = fromData.useDataChange({ viewPath,
context: 'appointment_overlay',
path: 'note',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Appointment Notes"
 color={dtColorsNeutral900}
 weight="medium"
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pt-2-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Editor
  viewPath={`${viewPath}/Editor`}
>
{childProps => (
<InlineNoteEditor
{...childProps}
  viewPath={`${viewPath}/InlineNoteEditor`}
 containerId="note-template"
 marginTop={0}
 marginBottom={0}
 width="100%"
 height={96}
 overflowY="auto"
 backgroundColor={dtColorsWhite}
 data="appointment_overlay.note"
 value={appointmentOverlayNoteValueData}
 onChange={appointmentOverlayNoteChangeData}
 toolbarPersist={true}
/>
)}
</Editor>
</div>
</div>
{children}
</React.Fragment>)
}